<template>
  <div class="cb-welcome">
    <h1 class="cb-heading-2">Welcome to CellBridge</h1>
    <p class="cb-body-1">
      Is your CellBridge device plugged in and displaying
      <button
        @click.prevent="handleOpenModalClick"
        aria-label="solid green lights?, opens troubleshooting modal."
        class="cb-link"
        id="troubleshoot-modal-button"
      >
        solid green lights</button
      >? If not, please plug it in before starting. When everything is green
      it’s time to test your system. If you need to run the full test, it should
      take less than 10 minutes and you may need to trigger your alarm siren.
    </p>
    <div class="cb-welcome__divider"></div>
    <button @click="handleContinueClick" class="cb-button cb-button--blue">
      Continue
    </button>
  </div>
</template>

<script>
/* global gtag */
import { mapActions } from 'vuex';

export default {
  mounted() {
    document.title = 'Welcome to ADT CellBridge';
  },
  methods: {
    handleContinueClick() {
      this.$router.push('/');
    },
    handleOpenModalClick() {
      this.openModal({
        modalContent: 'cbTroubleshoot',
        returnFocusID: 'troubleshoot-modal-button',
        closableOnBackgroundClick: true,
        closableOnEscapeKey: true,
        centeredOnMobile: false,
      });
      gtag('event', 'troubleshootClick', {
        event_label: 'solid green lights',
        event_category: 'welcome',
        value: 1,
      });
    },
    ...mapActions(['openModal']),
  },
};
</script>

<style lang="scss" scoped>
.cb-welcome {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0 28px;

  h1 {
    margin: 28px 0 12px;
  }

  p {
    margin: 0 0 40px;

    .cb-link {
      font-weight: 600;
    }
  }

  &__divider {
    display: none;
  }

  @include desktop {
    padding: 0 20px;

    h1 {
      margin: 48px 40px 12px;
    }

    p {
      flex-grow: 1;
      margin: 0 40px;
    }

    &__divider {
      display: block;
      height: 1px;
      background-color: $light-blue-grey;
    }

    .cb-button {
      align-self: flex-end;
      margin: 20px 0;
    }
  }
}
</style>
